import { map } from 'ramda';
import { UseFormSetValue } from 'react-hook-form';

import useConditionalCallback from './useConditionalCallback';

interface UseResetFieldParams<Type> {
	condition: ((T: Type) => boolean) | (() => boolean);
	fields: string[];
	fieldValue: Type;
	setValue: UseFormSetValue<
		Partial<{
			[x: string]: string | boolean | undefined;
		}>
	>;
	defaultValue?: unknown;
}

export default <Type>({
	fieldValue,
	condition,
	fields,
	setValue,
	defaultValue = null,
}: UseResetFieldParams<Type>) => {
	useConditionalCallback<Type>({
		value: fieldValue,
		condition,
		callback: () =>
			map((field) => {
				setValue(field, defaultValue, { shouldValidate: true });
			}, fields),
	});
};
